import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const envelope_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M13.9902,11.9997 L19.5002,17.4997 M4.5,17.4997
      L10,11.9997 M19.5,6.5002 L11.98,14.0002 L4.5,6.5002 M4.5,17.5 L19.5,17.5 L19.5,6.5
      L4.5,6.5 L4.5,17.5 Z"
      />
    </svg>
  );
};
